import React from "react";
import "./VideoSlider.css";

const VideoSlider = ({ desktopVideoSrc, mobileVideoSrc }) => {
  return (
    <div className="section video-section">
      <video
        className="video desktop-video"
        src={desktopVideoSrc}
        type="video/mp4"
        muted
        loop
        autoPlay
        playsInline
        preload="auto"
        aria-hidden="true"
      />
      <video
        className="video mobile-video"
        src={mobileVideoSrc}
        type="video/mp4"
        muted
        loop
        autoPlay
        playsInline
        preload="auto"
        aria-hidden="true"
      />
    </div>
  );
};

export default VideoSlider;